import styled from 'styled-components';

const ButtonBase = styled.button`
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: auto;
  height: auto;
  padding: 0;
  margin: 0;
  font-family: ${props => props.fontFamily || 'inherit'};
  font-size: 14px;
  font-weight: 400;
  text-decoration: none;
  line-height: initial;
  -webkit-tap-highlight-color: transparent;
  color: inherit;
  background: transparent;
  outline: 0;
  border: 0;
  border-radius: 0;
  cursor: pointer;
  user-select: none;
  vertical-align: middle;
  appearance: none;

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }

  &:hover {
    background: transparent;
  }
`;

export default ButtonBase;
